import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { ContentProvider,Types, ContentMessage } from '../../../../CommonComponents/ContentMessages';
import { getAPIData, initializeValues, generateAccesKey, updateAdditionalData } from "./actions";
import {
  PageHeadingWrapper,
  SummaryDetailsWrapper,
  FixedWidth,StepperWrapper
} from "./styles";
import PageSummary from "../../../../CommonComponents/PageSummary/PageSummary";
import BreadcrumbComponent from "../../../../CommonComponents/Breadcrumb/Breadcrumb";
import PageAccountSummary from "../../../../CommonComponents/PageSummary/PageAccountSummary/PageAccountSummary";
import ContributionType from "./Components/ContributionType/ContributionType";
import InvestmentOptions from "./Components/InvestmentOptions/InvestmentOptions";
import ReviewContributionAndSubmit from "./Components/ReviewContributionAndSubmit/ReviewContributionAndSubmit";
import FundingInstructions from "./Components/FundingInstructions/FundingInstructions";
import Popup from "./Components/ContributionType/Components/Popup/Popup";
import {
  getPrimaryAccount,
  getAccountData } from "../../../../utils/sessionUtil";
import { startDate, todayDate } from "../../../../utils/commonUtil";
import GenericStepper from '../../../../CommonComponents/RecommendFlow/GenericStepper/GenericStepper';
import Alert from "../../../../CommonComponents/Info/Alert/Alert";                   
import {
  defaultMutualFundAHAV,
  defaultSecurityGiftAHAV,
  defaultMutualFundAHOV,
  defaultSecurityGiftAHOV,
  defaultCheck,
  defaultStock,
  defaultAllocation
} from "./Components/CommonComponents/Data";
import history from "../../../../history/history";
import Preloader from "../../../../CommonComponents/Preloader/Preloader";
import { initiateTracking } from "../../../../utils/commonUtil";
import {InvestmentAllocationStep} from "./Components/CommonComponents/InfoRectangle/InfoRectangle";
import {ContributionTypeStep} from "./Components/CommonComponents/InfoRectangle/ContributionTypeStep";
import { RecommendGrantStep } from "../../../Grants/Pages/RecommendGrant/Component/InfoRectangle/InfoRectangle";
import { getFreezeFeaturesList } from '../../../../utils/freezeUtil';
import { macMainPageState } from "./selectors";

class MakeAContribution extends React.Component {
  constructor(props) {
    super(props);
    this.affixRef = React.createRef();
    this.state = {
      userCanContribute: true,
      isReadAccess: false,
      isAccountFreezed: false,
      stepperConfig: [
        {
          key: 1,
          route: "/contributions/make-a-contribution",
          description: "Select contribution type",
          stepContent: (this.props.history.location.pathname ===
            "/contributions/make-a-contribution/funding-instructions" || (this.props.history.location.state && (this.props.history.location.state.advisorType === "step1Edit" || this.props.location.state.advisorType === "step2Edit" ))) ? undefined : () => ( <> <RecommendGrantStep prefixId="contrib-step1" link="/contributions/make-a-contribution" analyticsTracking={ (value) => this.analyticsEditTracking('Edit - Step 1 Select contribution type - Stepper', value)} ><ContributionTypeStep data={this.props.contributionDetails} /></RecommendGrantStep></>),
          mainContent: () => (
            <ContributionType />
          )
        },
        {
          key: 2,
          route: "/contributions/make-a-contribution/investment-allocation",
          description: "Investment allocation options",
           stepContent: (this.props.history.location.pathname ===
            "/contributions/make-a-contribution/funding-instructions" || (this.props.history.location.state && (this.props.history.location.state.advisorType === "step1Edit" || this.props.history.location.state.advisorType === "step2Edit" ))) ? undefined : () => ( <><RecommendGrantStep prefixId="contrib-step2" link="/contributions/make-a-contribution/investment-allocation" analyticsTracking={ (value) => this.analyticsEditTracking('Edit - Step 2 Investment allocation options - Stepper', value)}><InvestmentAllocationStep data={this.props.allocationData} preference={this.props.allocationPreference}/></RecommendGrantStep></>),
          mainContent: () => (
            <InvestmentOptions />
          )
        },
        {
          key: 3,
          route: "/contributions/make-a-contribution/review",
          description: "Review contribution and submit",
          mainContent: () => (
            <ReviewContributionAndSubmit />
          )
        },
        {
          key: 4,
          route: "/contributions/make-a-contribution/funding-instructions",
          description: "View funding instructions",
          mainContent: () => (
            <FundingInstructions />
          )
        }
      ]
    };
  }

  stepperConfig = () => { 
    return ([
    {
      key: 1,
      route: "/contributions/make-a-contribution",
      description: "Select contribution type",
      stepContent: (this.props.location.pathname ===
        "/contributions/make-a-contribution/funding-instructions" || (this.props.history.location.state && (this.props.history.location.state.advisorType === "step1Edit" || this.props.history.location.state.advisorType === "step2Edit" ))) ? undefined : () => ( <> <RecommendGrantStep link="/contributions/make-a-contribution" analyticsTracking={ (value) => this.analyticsEditTracking('Edit - Step 1 Select contribution type - Stepper', value)}><ContributionTypeStep data={this.props.contributionDetails} /></RecommendGrantStep></>),
      mainContent: () => (
        <ContributionType />
      )
    },
    {
      key: 2,
      route: "/contributions/make-a-contribution/investment-allocation",
      description: "Investment allocation options",
       stepContent: (this.props.location.pathname ===
        "/contributions/make-a-contribution/funding-instructions" || (this.props.history.location.state && (this.props.history.location.state.advisorType === "step1Edit" || this.props.history.location.state.advisorType === "step2Edit" ))) ? undefined : () => ( <><RecommendGrantStep link="/contributions/make-a-contribution/investment-allocation" analyticsTracking={ (value) => this.analyticsEditTracking('Edit - Step 2 Investment allocation options - Stepper', value)}><InvestmentAllocationStep data={this.props.allocationData} preference={this.props.allocationPreference}/></RecommendGrantStep></>),
      mainContent: () => (
        <InvestmentOptions />
      )
    },
    {
      key: 3,
      route: "/contributions/make-a-contribution/review",
      description: "Review contribution and submit",
      mainContent: () => (
        <ReviewContributionAndSubmit />
      )
    },
    {
      key: 4,
      route: "/contributions/make-a-contribution/funding-instructions",
      description: "View funding instructions",
      mainContent: () => (
        <FundingInstructions />
      )
    }
  ])
};


  componentWillMount() {
    let accountData = getPrimaryAccount();
    if(accountData.role){
      if (accountData.role.access.toLowerCase() === "all access") {
        let isFreeze = this.checkForFreeze();
        if (!isFreeze) {
          this.renderAPIData();
        } else {
          this.setState({ userCanContribute: false, isAccountFreezed: true });
        }
      } else {
        this.setState({ userCanContribute: false, isReadAccess: true });
      }
  }
  }

  checkForFreeze() {
    let accountData = getPrimaryAccount();
    let userData = JSON.parse(sessionStorage.getItem('userData'));
    const thisFlow = 'MAC';
    let isFreeze = false;
    const freezesArray = getFreezeFeaturesList(userData.partyFreezes, accountData.freezes);
    isFreeze = freezesArray.indexOf(thisFlow) !== -1;
    return isFreeze;
}

  renderAPIData = () => {
    let data = {};
        if (process.env.REACT_APP_NODE_ENV === "development") {
          data = {
            metaData: {
              method: "GET",
              page: "makeAContribution",
              url: {
                investmentAllocation: `/makeAContribution/allocations/investmentAllocation`,
                fundDetails: `/makeAContribution/fundDetails/getFundAndSecurityDetails`,
                dropDownValues: "/npaAccount/dropdownValues/dropDown",
                loggedInAddress: "/makeAContribution/Address/loggedInAddress",
                additionalDetails: "/makeAContribution/additional/details",
                yearWiseBalance: "/makeAContribution/Balance/yearWise",
                relationShipValues:{
                  url:"/DP/Relationship/Types",
                  isBhoomiUrl:false
                }
              }
            }
          };
        } else {
          data = {
            metaData: {
              method: "GET",
              page: "MakeAContribution",
              url: {
                investmentAllocation: `/donor-portal/api/investmentOptions/findInvestmentOptionsByAccountIdFromDateAndToDate?accountId=${
                  getPrimaryAccount().userId
                }&fromDate=${startDate(3)}&toDate=${todayDate()}`,
                fundDetails: "/donor-portal/api/contribution/getRetailFundDetails",
                dropDownValues:
                  "/donor-portal/api/dropDownValues/getCodeValueMapping",
                loggedInAddress: `/donor-portal/api/profile/${
                  getAccountData().partyId
                }/findLoggedInAddressByPartyId`,
                additionalDetails: `/donor-portal/api/account/${
                  getPrimaryAccount().userId
                }/findBalancesAndVGAccessKey`,
                yearWiseBalance: `/donor-portal/api/contribution/${
                  getPrimaryAccount().userId
                }/checkForFirstContributionByAccountId`,
                relationShipValues:{
                  url:"/DP/Relationship/Types",
                  isBhoomiUrl:true
                }

              }
            }
          };
        }
        this.props.InitializeData(
          JSON.parse(JSON.stringify(defaultMutualFundAHAV))
        );
        this.props.getAPIData(data);
        window.scrollTo(0, 0);
  }

  componentWillReceiveProps(nextProps){
    if(!(nextProps.location.state && this.props.location.pathname === "/contributions/make-a-contribution/investment-allocation" && nextProps.location.pathname === '/contributions/make-a-contribution' && nextProps.location.state.source !== '')){
    if(this.props.location.state && this.props.location.state.source && nextProps.location.state && nextProps.location.state.source && (this.props.location.state.source === "header" || this.props.location.state.source === "headerReload")){
      if((this.props.location.state.source === "header" && nextProps.location.state.source === "headerReload") || (this.props.location.state.source === "headerReload" && nextProps.location.state.source === "header")){
        this.renderAPIData();
      }
    }
    if(nextProps.location.state && nextProps.location.state.source && (nextProps.location.state.source === "header" || nextProps.location.state.source === "headerReload")){
      if(nextProps.location.pathname === "/contributions/make-a-contribution" && this.props.location.pathname !== "/contributions/make-a-contribution"){
        this.renderAPIData();
      }
    }
    if(nextProps.location.pathname !== this.props.location.pathname){
        let stepConfig = this.stepperConfig();
        this.setState({stepperConfig: stepConfig})
    }
  }
  }

  fundSummaryConfiguration = (headerData) => {
    const userDetails = getPrimaryAccount();
    return [
      this.renderFundSummary({
        key: "fundName",
        label: userDetails.accountName,
        value: userDetails.accountNumber,
        type: "accountName"
      }),
      this.renderFundSummary({
        key: "currentBalance",
        label: "Current Balance",
        value: headerData
          ? (headerData.currentBalance !== 0 ? headerData.currentBalance : '0.00')
          : "",
        type: "Dollars"
      }),
      this.renderFundSummary({
        key: "availableBalance",
        label: "Available Balance",
        value: headerData
          ? (headerData.availableBalance !== 0 ? headerData.availableBalance : '0.00')
          : "",
        type: "Dollars"
      })
      
    ];
  };

  renderFundSummary = obj => {
    return (
      <PageAccountSummary
        key={obj.key}
        label={obj.label}
        value={obj.value}
        dataName={obj.type}
      />
    );
  };

  navigateToDashBoard = () => {
   history.push("/contributions");
  };

  analyticsEditTracking = (value, previousPage) => {
    let eventAction = '';
    if(previousPage === '/contributions/make-a-contribution/investment-allocation'){
      eventAction = 'Step 2 Investment allocation options';
    } else if(previousPage === '/contributions/make-a-contribution/review'){
      eventAction = 'Step 3 Review contribution and submit';
    }
    initiateTracking('edit','Make a contribution', eventAction ,value);
  }

  warningAccessContent = {
    heading: "Contributions cannot be done",
    line1:  "Contributions cannot be made using this account because of Read Only Access.",
    line2: "Click Continue to navigate to Contribution Dashboard",
    continue: "continue",
    cancel: "",
    type: "Info"
  }

  warningContent = {
    heading: "Contributions cannot be done",
    line1: "Transactions for this account are frozen; Contact us at 888-383-4483 or questions@vanguardcharitable.org.",
    line2: "Click Continue to navigate to Contribution Dashboard",
    continue: "continue",
    cancel: "",
    type: "Info"
  }

  render() {
    let mainHeading = this.props.drupalData && this.props.drupalData.pageInfo.field_page_title ? this.props.drupalData.pageInfo.field_page_title : "Make a contribution";
    let stepConfig = this.state.stepperConfig;
    let headerData = this.props.additionalDetails;
    this.breadcrumbRoutes = () => {
      return [
        {
          routeName: "Home",
          path: "/"
        },
        {
          routeName: "Contributions",
          path: "/contributions"
        },
        {
          routeName: "Make a contribution",
          path: "/contributions/make-a-contribution"
        }
      ];
    };
    if(this.props.additionalAccountDetails && this.props.additionalAccountDetails.currentBalance >= 0){
      headerData = this.props.additionalAccountDetails;
    }
    if(this.state.userCanContribute){
    return (
      <ContentProvider
        types={[Types.PAGE_TITLE_DESCRIPTION]}
        pages={['Make a Contribution']}
      >
          <FixedWidth className='contribution-stepper-fix' ref={this.affixRef}> 
            <BreadcrumbComponent role="navigation" breadcrumbRoutes={this.breadcrumbRoutes()} />
            <PageHeadingWrapper aria-level="1">
            <ContentMessage type={[Types.PAGE_TITLE_DESCRIPTION]} page="Make a Contribution" property="field_page_title" defaultMessage={mainHeading} />
            </PageHeadingWrapper>
            <SummaryDetailsWrapper>
              <PageSummary
                fundSummaryConfig={this.fundSummaryConfiguration(headerData)}
              />
            </SummaryDetailsWrapper>
            {this.props.history.location.pathname ===
                  "/contributions/make-a-contribution/investment-allocation" ? (
                    this.props.drupalData && this.props.drupalData.step2Notice && this.props.drupalData.step2Notice.field_notice_content ?
              <Alert type={'Notice'} 
              heading={ this.props.drupalData ?
              <div dangerouslySetInnerHTML={{ __html: this.props.drupalData.step2Notice.field_notice_content }} /> : "" }
              body={this.props.drupalData ? <div dangerouslySetInnerHTML={{ __html: this.props.drupalData.step2Notice.field_show_more_content }} /> : "" }
              hideButton={false}
            />
              : ''
            ) : null}
               { this.props.isAPICalled ? <StepperWrapper className="makeAContributionStepper"><GenericStepper  affixRef={this.affixRef} hideSteps={false} stepConfig={stepConfig} history={this.props.history} flowName="MAC"/></StepperWrapper> :<Preloader />}
          </FixedWidth>
          </ContentProvider>
    );
    }else {
      return (
      <Popup
              height="330px"
              width="510px"
              mwidth="88%"
              mheight="53%"
              data-test="popup"
              content={this.state.isReadAccess ? this.warningAccessContent : this.warningContent}
              closeModal={() => this.navigateToDashBoard()}
              handleRemove={() => this.navigateToDashBoard()}
              />
      )
          }
  }
}

MakeAContribution.propTypes = {
  additionalDetails: PropTypes.object,
  additionalAccountDetails: PropTypes.object,
  isDummyUpdated: PropTypes.bool,
  drupalData: PropTypes.object,
  isAPICalled: PropTypes.bool,
  allocationData: PropTypes.object,
  allocationPreference: PropTypes.string,
  getAPIData: PropTypes.func,
  InitializeData: PropTypes.func,
  generateAccesKey: PropTypes.func,
  updateAdditionalData: PropTypes.func
};

const mapStateToProps = state => ({
  ...macMainPageState(state.toJS())
});

export const mapDispatchToProps = dispatch => ({
  getAPIData: data => dispatch(getAPIData(data)),
  InitializeData: arr =>
    dispatch(
      initializeValues({
        mutualFundAV: arr,
        securityGiftAV: JSON.parse(JSON.stringify(defaultSecurityGiftAHAV)),
        mutualFundOV: JSON.parse(JSON.stringify(defaultMutualFundAHOV)),
        securityGiftOV: JSON.parse(JSON.stringify(defaultSecurityGiftAHOV)),
        check: JSON.parse(JSON.stringify(defaultCheck)),
        stock: JSON.parse(JSON.stringify(defaultStock)),
        allocation: JSON.parse(JSON.stringify(defaultAllocation))
      })
    ),
    generateAccesKey: (data) => dispatch(generateAccesKey(data)),
    updateAdditionalData: (data) => dispatch(updateAdditionalData(data))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MakeAContribution)
);
